/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import { Box, CircularProgress, Modal, Typography, Button, Chip, Menu, MenuItem, Checkbox, Divider, IconButton } from "@mui/material";
import { useTheme as useThemeHook } from "@mui/material/styles";
import { Controller, useWatch } from "react-hook-form";
import { useDispatch } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { ADD_VARIENTS_CONSTANTS } from "../../constants/lang";
import { fetchOptionTypeDetail } from "../../store/reducers/createProfile/apithunk";
import CustomModal from "../../components/CommonComponents/Modal";
import uploadImageIcon from "../../assets/images/upload-image-icon.svg";
import { ToastNotifyError } from "../../components/CommonComponents/Toast/ToastNotify";
import ImageCropper from "../../components/CommonComponents/ImageCroper";
import { uploadImage } from "../../store/reducers/authentication/apiThunk";
import CancelSharpIcon from "../../assets/images/cancelSharpIcon.svg";
import rollbar from "../../rollbarConfig";
import addProductVariantStyles from "./AddProductVariant.styles";
import AddNewVariantValueModal from "./AddNewVariantValueModal";

const AddProductVariant = ({ 
  variantId, 
  control, 
  errors, 
  onValueChange, 
  prefilledImages, 
  onRemoveVariant, 
  variantType: initialVariantType,
  variantOptions: initialVariantOptions = [],
  initialSelectedOptions = [],
  onVariantTypeAdded,
  onVariantDone,
  isEditing = false,
  onDiscard
}) => {
  const dispatch = useDispatch();
  const themeHook = useThemeHook();
  const styles = addProductVariantStyles(themeHook);
  const [images, setImages] = useState([]);
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [openCropperModal, setOpenCropperModal] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [imageUrl, setImageUrl] = useState(null);
  const [pendingImages, setPendingImages] = useState([]);
  const [finalImages, setFinalImages] = useState([]);
  const [firstImage, setFirstImage] = useState();
  const [selectedImage, setSelectedImage] = useState(null);
  const [open, setOpen] = useState(false);
  const [variantType, setVariantType] = useState(initialVariantType);
  const [variantOptions, setVariantOptions] = useState(initialVariantOptions);
  const [isLoadingOptions, setIsLoadingOptions] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const [openAddNewValueModal, setOpenAddNewValueModal] = useState(false);
  const hasInitializedFormValue = useRef(false);
  const lastInitialSelectedOptionsRef = useRef(initialSelectedOptions);
  
  const watchedVariantOption = useWatch({
    control,
    name: `variants.${variantId}.variantOption`,
    defaultValue: initialSelectedOptions || []
  });

  console.log("variantType", firstImage);
  useEffect(() => {
    if (prefilledImages) {
      setFinalImages(prefilledImages);
      setFirstImage(prefilledImages[0]);
      if(prefilledImages?.length > 0){
        const dummyFiles = prefilledImages?.map((url) => {
          const fileName = url.split('/').pop();
          return new File([''], fileName, { type: 'image/jpeg' });
        });
        setImages(dummyFiles);
      }
    }
  }, [prefilledImages]);

  const handleOpen = (image) => {
    setSelectedImage(image);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCancelCropper = () => {
    setOpenCropperModal(false);
  };

  const handleRemoveImage = (index) => {
    setImages((prevImages) => {
      const updatedImages = prevImages?.filter((_, i) => i !== index);
      return updatedImages;
    });
    setFinalImages((prev) => prev?.filter((_, i) => i !== index));
  };

  const handleImageUpload = (event) => {
    setIsLoading(true);
    const files = Array.from(event.target.files);
    if (files?.length + images?.length > 6) {
      ToastNotifyError("You can only upload up to 6 images.");
      event.target.value = "";
      setIsLoading(false);
      return;
    }

    const maxSize = 5 * 1024 * 1024;
    for (let file of files) {
      if (file?.size > maxSize) {
        ToastNotifyError("File size must be less than 5MB");
        event.target.value = "";
        setIsLoading(false);
        return;
      } else {
        setPendingImages(files);
        setIsLoading(false);
        setImageUrl(URL.createObjectURL(files[0]));
        setOpenCropperModal(true);
        event.target.value = "";
      }
    }
  };

  const handleImageCrop = async ({ file }) => {
    try {
      const response = await dispatch(uploadImage(file));
      const { key, uploadResponse } = response?.payload;
      const { status } = uploadResponse || {};
      if (status === 200) {
        const finalImage = process.env.REACT_APP_S3_IMAGES_URL + key;
        setImages((prevImages) => [...prevImages, file]);
        setFinalImages((prev) => [...prev, finalImage]);
      }
    } catch (err) {
      rollbar.error("Error message", err);
      console.error(err);
    }
    const nextImageIndex = currentImageIndex + 1;
    if (nextImageIndex < pendingImages?.length) {
      setCurrentImageIndex(nextImageIndex);
      setImageUrl(URL.createObjectURL(pendingImages[nextImageIndex]));
    } else {
      setOpenCropperModal(false);
      setCurrentImageIndex(0);
      setPendingImages([]);
    }
  };

  const closeModal = () => {
    setUploadModalOpen(false);
  };

  const onSaveModal = () => {
    setFirstImage(finalImages[0]);
    setUploadModalOpen(false);
    onValueChange(`variants.${variantId}.selectImage`, finalImages);
  };

  const handleRemoveVariantClick = () => {
    if (variantType && onVariantTypeAdded) {
      onVariantTypeAdded(variantType);
    }
    if (onRemoveVariant) {
      onRemoveVariant(variantId);
    }
  };

  // Effect to fetch latest option values when variant type is set (especially for edit mode)
  useEffect(() => {
    // Set initial variant type if provided
    if (initialVariantType && initialVariantType.id) {
      setVariantType(initialVariantType);
      
      // Always fetch latest values when variant type is set (important for edit mode)
      // This ensures we have the most up-to-date option values
      const fetchLatestOptions = async () => {
        setIsLoadingOptions(true);
        try {
          const res = await dispatch(fetchOptionTypeDetail(initialVariantType.id));
          const responseData = res?.payload || {};
          const { status, message, data } = responseData;
          console.log("message:", message);
          
          if (status && data) {
            const optionsArray = Array.isArray(data) ? data : [];
            
            // Transform the options to have 'name' property from 'value' field
            const transformedOptions = optionsArray?.map(option => ({
              id: option.id,
              name: option.value || option.name || String(option),
              ...option
            }));
            
            setVariantOptions(transformedOptions);
            
            if (onValueChange) {
              onValueChange(`variants.${variantId}.variantOptions`, transformedOptions);
            }
          }
        } catch (error) {
          console.error("Failed to fetch variant options:", error);
          rollbar.error("Error fetching variant options", error);
          if (initialVariantOptions?.length > 0) {
            setVariantOptions(initialVariantOptions);
          }
        } finally {
          setIsLoadingOptions(false);
        }
      };
      
      fetchLatestOptions();
    } else if (initialVariantOptions?.length > 0) {
      setVariantOptions(initialVariantOptions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialVariantType?.id]);

  useEffect(() => {
    const currentInitialIds = initialSelectedOptions?.map(opt => opt?.id)?.sort() || [];
    const lastInitialIds = lastInitialSelectedOptionsRef.current?.map(opt => opt?.id)?.sort() || [];
    const initialSelectedOptionsChanged = 
      JSON.stringify(lastInitialIds) !== JSON.stringify(currentInitialIds);
    
    if (initialSelectedOptionsChanged) {
      hasInitializedFormValue.current = false;
      lastInitialSelectedOptionsRef.current = initialSelectedOptions;
    }
    
    if (initialSelectedOptions?.length > 0 && onValueChange && initialVariantType && variantOptions?.length > 0) {
      if (!hasInitializedFormValue.current || initialSelectedOptionsChanged) {
        const matchedOptions = initialSelectedOptions
          ?.map(selectedOption => {
            const matched = variantOptions?.find(opt => opt?.id === selectedOption?.id);
            return matched || selectedOption;
          })
          ?.filter(Boolean);
        
        const currentFormValue = watchedVariantOption || [];
        const currentIds = currentFormValue?.map(opt => opt?.id)?.sort() || [];
        const matchedIds = matchedOptions?.map(opt => opt?.id)?.sort() || [];
        
        const shouldSet = 
          !currentFormValue || 
          currentFormValue?.length === 0 || 
          initialSelectedOptionsChanged ||
          (!hasInitializedFormValue.current && JSON.stringify(currentIds) !== JSON.stringify(matchedIds));
        
        if (shouldSet) {
          const timer = setTimeout(() => {
            onValueChange(`variants.${variantId}.variantOption`, matchedOptions);
            hasInitializedFormValue.current = true;
            lastInitialSelectedOptionsRef.current = initialSelectedOptions;
          }, 150);
          return () => clearTimeout(timer);
        } else {
          hasInitializedFormValue.current = true;
          lastInitialSelectedOptionsRef.current = initialSelectedOptions;
        }
      }
    } else if (!initialSelectedOptions || initialSelectedOptions.length === 0) {
      hasInitializedFormValue.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialSelectedOptions, variantId, onValueChange, initialVariantType, variantOptions?.length]);

  const handleDone = () => {
    if (!variantType) {
      ToastNotifyError("Please select a variant option name.");
      return;
    }
    const currentOptions = watchedVariantOption || [];
    if (!currentOptions || currentOptions?.length === 0) {
      ToastNotifyError("Please select at least one variant option value.");
      return;
    }
    if (onVariantDone) {
      onVariantDone(variantId, variantType, currentOptions);
    }
  };

  useEffect(() => {
    const errorMessage = errors?.variants?.[variantId]?.selectImage?.message;
    if (errorMessage) {
      ToastNotifyError(errorMessage);
    }
  }, [errors?.variants?.[variantId]?.selectImage]);

  const handleRemoveOption = (optionToRemove, fieldOnChange, currentValue) => {
    const updatedValue = currentValue?.filter(opt => opt?.id !== optionToRemove?.id);
    fieldOnChange(updatedValue);
  };

  return (
    <Box sx={styles.variantContainer}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
        <Typography sx={{
          fontFamily: 'Lexend',
          fontSize: '12px',
          fontWeight: 400,
          color: '#0F0F0F',
        }}>
          Variant Type Name & Options
        </Typography>
        {onDiscard && (
          <IconButton
            size="small"
            onClick={onDiscard}
            sx={{
              color: themeHook?.palette?.customColor?.red || "#D32F2F",
              padding: '4px',
              '&:hover': {
                backgroundColor: themeHook?.palette?.action?.hover || "rgba(0, 0, 0, 0.04)",
              }
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
      
      <Box sx={{ border: `1px solid ${themeHook?.palette?.customColor?.secondaryThird || "#E0E0E0"}` }}>
      {variantType && (
        <Box sx={{ py: "15px", px: "16px" }}>
          <Typography sx={{
            fontFamily: 'Lexend',
            fontSize: '16px',
            fontWeight: 400,
            color: themeHook?.palette?.primary?.main || '#0F0F0F',
          }}>
            {variantType.name}
          </Typography>
        </Box>
      )}

      <Divider sx={{borderColor: themeHook?.palette?.customColor?.secondaryThird || "#E0E0E0" }} />

      <Controller
        name={`variants.${variantId}.variantOption`}
        control={control}
        defaultValue={initialSelectedOptions || []}
        render={({ field }) => {
          const fieldValue = Array.isArray(field.value) ? field.value : (initialSelectedOptions || []);
          
          return (
            <>
              {fieldValue?.length > 0 && (
                <Box sx={{ px: "16px", pt: "15px", pb: "15px", display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
                  {fieldValue?.map((option) => (
                      <Chip
                        key={option?.id}
                        label={option?.name || option?.value}
                        onDelete={() => handleRemoveOption(option, field.onChange, fieldValue)}
                        deleteIcon={
                          <Box
                            component="span"
                            sx={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              width: '20px',
                              height: '20px',
                              '& svg': {
                                width: '20px',
                                height: '20px',
                                fontSize: '20px',
                              }
                            }}
                          >
                            <CloseIcon />
                          </Box>
                        }
                      sx={{
                        fontFamily: 'Lexend',
                        fontSize: '14px',
                        fontWeight: 400,
                        height: '28px',
                        borderRadius: '0px',
                        backgroundColor:'#F0F0F0',
                        color: themeHook?.palette?.primary?.main || '#0F0F0F',
                        '& .MuiChip-deleteIcon': {
                          color: themeHook?.palette?.text?.secondary || '#656565',
                          width: '20px',
                          height: '20px',
                          fontSize: '20px !important',
                          margin: '0',
                          '& svg': {
                            width: '20px !important',
                            height: '20px !important',
                            fontSize: '20px !important',
                          },
                          '&:hover': {
                            color: themeHook?.palette?.customColor?.red || '#D32F2F',
                          }
                        },
                        '& .MuiChip-label': {
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          paddingLeft: option?.hex_code ? '4px' : '12px',
                          paddingRight: '4px',
                        }
                      }}
                      icon={
                        option?.hex_code ? (
                          <Box
                            sx={{
                              width: '20px',
                              height: '20px',
                              mr: '4px !important',
                              backgroundColor: option?.hex_code,
                              border: `1px solid ${themeHook?.palette?.customColor?.secondaryThird || "#E0E0E0"}`,
                              flexShrink: 0,
                            }}
                          />
                        ) : null
                      }
                    />
                  ))}
                </Box>
              )}
            </>
          );
        }}
      />

      {variantType && (
        <Button
          variant='text'
          onClick={(e) => setAnchorEl(e.currentTarget)}
          disabled={isLoadingOptions || variantOptions?.length === 0}
          sx={{
            fontFamily: 'Lexend',
            fontSize: '14px',
            fontWeight: 400,
            color: themeHook?.palette?.primary?.main || '#0F0F0F',
            textTransform: 'none',
            minWidth: 'auto',
            px: "16px",
            pb: "15px",
            '&:hover': {
              backgroundColor: 'transparent',
              textDecoration: 'underline',
            }
          }}
        >
          +Add {variantType?.name}
        </Button>
      )}

      <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={() => setAnchorEl(null)}
        PaperProps={{
          sx: {
            mt: 1,
            minWidth: 200,
            maxHeight: 400,
          }
        }}
      >
        {variantOptions?.length > 0 ? (
          <>
            {variantOptions?.map((option) => {
              const currentFormValue = watchedVariantOption || [];
              const isSelected = currentFormValue?.some(opt => opt?.id === option?.id);
              return (
                <MenuItem
                  key={option?.id}
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    const currentValue = watchedVariantOption || [];
                    let updatedValue;
                    if (isSelected) {
                      updatedValue = currentValue?.filter(opt => opt?.id !== option?.id) || [];
                    } else {
                      if (currentValue?.length >= 5) {
                        ToastNotifyError("You can select up to 5 values only.");
                        return;
                      }
                      updatedValue = [...currentValue, option];
                    }
                    onValueChange(`variants.${variantId}.variantOption`, updatedValue);
                  }}
                  sx={{
                    fontFamily: 'Lexend',
                    fontSize: '14px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    py: 1.5,
                  }}
                >
                  <Checkbox
                    checked={isSelected}
                    sx={{
                      color: themeHook?.palette?.primary?.main || '#0F0F0F',
                      '&.Mui-checked': {
                        color: themeHook?.palette?.primary?.main || '#0F0F0F',
                      },
                      padding: '4px',
                    }}
                  />
                  {option?.hex_code && (
                    <Box
                      sx={{
                        width: '20px',
                        height: '20px',
                        borderRadius: '2px',
                        backgroundColor: option?.hex_code,
                        border: `1px solid ${themeHook?.palette?.customColor?.secondaryThird || "#E0E0E0"}`,
                        flexShrink: 0,
                      }}
                    />
                  )}
                  <Box sx={{ flex: 1 }}>{option?.name || option?.value}</Box>
                </MenuItem>
              );
            })}
            <Divider />
            <MenuItem
              onClick={(e) => {
                e.stopPropagation();
                setAnchorEl(null);
                setOpenAddNewValueModal(true);
              }}
              sx={{
                fontFamily: 'Lexend',
                fontSize: '14px',
                py: 1.5,
                color: themeHook?.palette?.primary?.main || '#0F0F0F',
                fontWeight: 400,
              }}
            >
              +Add New
            </MenuItem>
          </>
        ) : (
          <>
            <MenuItem disabled sx={{ fontFamily: 'Lexend', fontSize: '14px' }}>
              No options available
            </MenuItem>
            <Divider />
            <MenuItem
              onClick={(e) => {
                e.stopPropagation();
                setAnchorEl(null);
                setOpenAddNewValueModal(true);
              }}
              sx={{
                fontFamily: 'Lexend',
                fontSize: '14px',
                py: 1.5,
                color: themeHook?.palette?.primary?.main || '#0F0F0F',
                fontWeight: 400,
              }}
            >
              +Add New
            </MenuItem>
          </>
        )}
      </Menu>
      </Box>

      {/* Delete and Done Buttons */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
        <Button
          variant='outlined'
          onClick={handleRemoveVariantClick}
          sx={{
            borderColor: themeHook?.palette?.customColor?.red || "#D32F2F",
            color: themeHook?.palette?.customColor?.red || "#D32F2F",
            fontFamily: 'Lexend',
            fontSize: '14px',
            fontWeight: 400,
            textTransform: 'none',
            borderRadius: '4px',
            px: 3,
            py: 1,
            backgroundColor: themeHook?.palette?.customColor?.white || "#FFFFFF",
            '&:hover': {
              borderColor: themeHook?.palette?.customColor?.red || "#D32F2F",
              backgroundColor: 'rgba(211, 47, 47, 0.04)',
            }
          }}
        >
          Delete
        </Button>
        <Button
          variant='contained'
          onClick={handleDone}
          sx={{
            backgroundColor: themeHook?.palette?.primary?.main || "#0F0F0F",
            color: themeHook?.palette?.customColor?.white || "#FFFFFF",
            fontFamily: 'Lexend',
            fontSize: '14px',
            fontWeight: 400,
            textTransform: 'none',
            borderRadius: '4px',
            px: 3,
            py: 1,
            '&:hover': {
              backgroundColor: themeHook?.palette?.primary?.dark || "#000000",
            }
          }}
        >
          Done
        </Button>
      </Box>
      <CustomModal
        open={uploadModalOpen}
        onClose={() => closeModal()}
        onSave={() => onSaveModal()}
        title='Upload variant image'
      >
        <>
          <label htmlFor={`imageUpload-${variantId}`}>
            <Box sx={styles.modalUploadWrap}>
              <Box sx={styles.modalImageWrap}>
                <input
                  type='file'
                  id={`imageUpload-${variantId}`}
                  multiple
                  accept='image/png, image/jpeg'
                  hidden
                  onChange={handleImageUpload}
                />
                <img src={uploadImageIcon} alt='upload' width='24px' />
                <Typography sx={styles.modalImageText}>
                  Upload Media
                </Typography>
              </Box>
              <Box sx={styles.imageValidationWrap}>
                <Typography sx={styles.modalImageValidationText}>
                  {ADD_VARIENTS_CONSTANTS.maxImage}
                </Typography>
                <Typography sx={styles.modalImageValidationText}>
                  {ADD_VARIENTS_CONSTANTS.imageSupport}
                </Typography>
              </Box>
            </Box>
          </label>
          <Box sx={styles.modalImagePreviewWrap}>
            {images?.map((image, index) => (
              <Box key={index} sx={styles.modalImagePreview}>
                {isLoading ? (
                  <Box sx={styles.loadingWrap}>
                    <CircularProgress size={24} sx={styles.loadingIcon} />
                  </Box>
                ) : (
                  <img
                    src={finalImages[index] || URL.createObjectURL(image)}
                    alt={`uploaded-${index}`}
                    width='20px'
                    onClick={() => handleOpen(image)}
                    style={{ cursor: "pointer" }}
                  />
                )}
                <Box
                  sx={styles.modalImageCrossIcon}
                  onClick={() => handleRemoveImage(index)}
                >
                  <img src={CancelSharpIcon} width='20px' alt='cancleIcon' />
                </Box>
              </Box>
            ))}
          </Box>
          <Modal open={open} onClose={handleClose}>
            <Box sx={styles.imagePreviewModal}>
              <Box>
                <img
                  src={selectedImage ? URL.createObjectURL(selectedImage) : ""}
                  alt='Full Preview'
                  style={{
                    width: "70vw",
                    height: "70vh",
                    objectFit: "contain",
                  }}
                />
                <img
                  src={CancelSharpIcon}
                  onClick={handleClose}
                  alt='Close'
                  style={{
                    position: "absolute",
                    top: 70,
                    right: 70,
                    cursor: "pointer",
                    fontSize: 50,
                  }}
                />
              </Box>
            </Box>
          </Modal>
        </>
      </CustomModal>
      <Modal
        open={openCropperModal}
        onClose={() => setOpenCropperModal(false)}
        closeAfterTransition
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backdropFilter: "blur(3px)",
        }}
      >
        <Box sx={styles.cropperModal}>
          <Box sx={styles.imageCropDisplay}>
            {imageUrl && (
              <ImageCropper
                src={imageUrl}
                onCancel={handleCancelCropper}
                onCropComplete={handleImageCrop}
              />
            )}
          </Box>
        </Box>
      </Modal>

      {/* Add New Variant Value Modal */}
      <AddNewVariantValueModal
        open={openAddNewValueModal}
        onClose={() => setOpenAddNewValueModal(false)}
        optionTypeId={variantType?.id}
        isColorVariant={variantType?.name?.toLowerCase() === 'color' || variantOptions?.some(opt => opt?.hex_code)}
        currentOptionCount={variantOptions?.length}
        onSuccess={async () => {
          // Refresh variant options after creating new values
          if (variantType && variantType?.id) {
            setIsLoadingOptions(true);
            try {
              const res = await dispatch(fetchOptionTypeDetail(variantType?.id));
              const responseData = res?.payload || {};
              const { status, data } = responseData;
              
              if (status && data) {
                const optionsArray = Array.isArray(data) ? data : [];
                const transformedOptions = optionsArray?.map(option => ({
                  id: option?.id,
                  name: option?.value || option?.name || String(option),
                  hex_code: option?.hex_code || (option?.metadata?.hex_code),
                  ...option
                }));
                setVariantOptions(transformedOptions);
                if (onValueChange) {
                  onValueChange(`variants.${variantId}.variantOptions`, transformedOptions);
                }
              }
            } catch (error) {
              console.error("Failed to refresh variant options:", error);
            } finally {
              setIsLoadingOptions(false);
            }
          }
        }}
      />
    </Box>
  );
};

export default AddProductVariant;

